import React from 'react';
import './status-badge.css';

const TONES = {
  ONGOING: 'ongoing',
  PENDING: 'live',
  CREATED: 'live',
  PROCESSING: 'live',
  IN_PROGRESS: 'live',
  COMPLETED: 'completed',
  PUBLISHED: 'published',
  FAILED: 'danger',
  CANCELLED: 'danger',
};

const SHORT_LABELS = {
  COMPLETED: 'Done',
  PUBLISHED: 'Pub',
  PROCESSING: 'Run',
  IN_PROGRESS: 'Run',
  PENDING: 'Wait',
  CREATED: 'Wait',
  FAILED: 'Fail',
  CANCELLED: 'Fail',
};

export const statusTone = (status) => TONES[String(status || '').toUpperCase()] || 'neutral';

/** Pill for a backend status value; `compact` uses short labels for dense tables. */
export default function StatusBadge({ status, compact = false, title }) {
  if (!status) return null;
  const value = String(status).toUpperCase();
  const label = compact ? (SHORT_LABELS[value] || value.slice(0, 4)) : value.replaceAll('_', ' ');

  return (
    <span
      className={`status-badge status-badge-${statusTone(value)}${compact ? ' status-badge-compact' : ''}`}
      title={title}
    >
      <span className="status-badge-dot" />
      {label}
    </span>
  );
}
